<template>
    <v-layout align-center align-content-space-between>
        <v-spacer></v-spacer>
        <v-progress-circular
            class="mr-2"
            v-if="loading"
            :size="30"
            color="primary"
            indeterminate
        ></v-progress-circular>
        <div>
            {{
                $t("$vuetify.dataIterator.pageText", [
                    (page - 1) * 20,
                    page * 20 > total ? total : page * 20,
                    total,
                ])
            }}
        </div>

        <v-btn icon outlined :disabled="page == 1" @click="$emit('previous')">
            <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>

        <v-btn icon outlined :disabled="pages == page" @click="$emit('next')">
            <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
    </v-layout>
</template>
<script>
export default {
    props: {
        page: { type: Number, default: 1 },
        loading: { type: Boolean, default: false },
        pages: { type: Number, default: 0 },
        total: { type: Number, default: 0 },
    },
}
</script>
